import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler } from 'services';
import {
  AbonedInvoiceJustificationActions as Actions,
  AbonedInvoiceJustificationRequestAction as RequestAction,
} from 'store/ducks/invoiceJustifications';

export function* abonedInvoiceJustificationRequest(action: any) {
  const { id, onSuccess, onFailure }: RequestAction = action;
  try {
   
    const { data } = yield call(api.put, `invoice/justifications/aboned/${id}`);
    onSuccess && onSuccess();
    yield put(Actions.success(data));
  } catch (error) {
    const { errorMessage } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage));
  }
}
